import { motion } from "framer-motion";
import { GraduationCap, Scale, Award, MapPin } from "lucide-react";

const BADGES = [
  { icon: Award, label: "21 Years Trial Practice" },
  { icon: Scale, label: "State Bar of California" },
  { icon: GraduationCap, label: "CAALA Active Member" },
  { icon: MapPin, label: "Wilshire Blvd Los Angeles HQ" },
];

export const Attorney = () => (
  <section id="attorney" className="border-y border-gold/10 bg-navy-900/40">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-24 lg:grid-cols-2 lg:px-8">
      <motion.div
        data-testid="attorney-profile-sam-heidari"
        initial={{ opacity: 0, x: -32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="relative"
      >
        <div className="absolute -inset-3 rounded-2xl border border-gold/30" />
        <img
          src="https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBhdHRvcm5leSUyMGxhd3llciUyMHBvcnRyYWl0JTIwc3VpdHxlbnwwfHx8fDE3OTM4MDk2MDR8MA&ixlib=rb-4.1.0&q=85"
          alt="Sam Ryan Heidari, Founder & Senior Managing Attorney"
          className="relative aspect-[4/5] w-full rounded-xl object-cover"
        />
        <div className="absolute bottom-5 left-5 rounded-lg border border-gold/25 bg-navy-950/85 px-5 py-3 backdrop-blur-md">
          <div className="font-display text-lg font-semibold text-slate-50">Sam Ryan Heidari</div>
          <div className="font-mono text-[11px] tracking-widest text-gold uppercase">Founder · Senior Managing Attorney</div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
      >
        <p className="mb-3 font-mono text-xs tracking-[0.35em] text-gold/80 uppercase">Lead Counsel</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-50">
          Two Decades of Unyielding Advocacy
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate-300/90">
          For over 21 years, Sam Ryan Heidari has championed individuals facing overwhelming
          corporate and insurance opposition. Licensed by the State Bar of California and an
          active member of CAALA, he has built Heidari Law Group on unyielding trial
          preparation, strategic precision, and genuine client empathy — turning complex,
          high-stakes legal challenges into landmark recoveries.
        </p>
        <p className="mt-4 text-base leading-relaxed text-slate-300/90">
          From catastrophic injury to workplace injustice and civil rights violations, he leads
          complex pre-litigation and trial teams that hold powerful corporations, insurers, and
          employers accountable.
        </p>
        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {BADGES.map((b) => (
            <div key={b.label} className="flex items-center gap-3 rounded-lg border border-gold/15 bg-navy-900 px-4 py-3 transition-colors hover:border-gold/40">
              <b.icon size={18} className="shrink-0 text-gold" />
              <span className="text-sm font-medium text-slate-200">{b.label}</span>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
